import {
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  computed,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { injectFeedOperatorHintsQuery } from 'src/app/api/queries/feed.queries';
import { FeedOperatorHint } from '../../../core/services/feed.service';
import { NomObjectTypes } from '../../../core/constants';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SuiButtonComponent } from '@sui/button';
import { FeedOperatorListComponent } from './feed-operator-list/feed-operator-list.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-feed-query-hints-popup',
  templateUrl: './feed-query-hints-popup.component.html',
  styleUrl: './feed-query-hints-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.sidebar-open]': "sidebar() === 'open'",
    '[class.sidebar-closed]': "sidebar() === 'closed'",
  },
  imports: [
    CdkDrag,
    CdkDragHandle,
    FaIconComponent,
    SuiButtonComponent,
    FeedOperatorListComponent,
    AsyncPipe,
  ],
})
export class FeedQueryHintsPopupComponent {
  @Input() objectTypeId: NomObjectTypes;

  // Where the feed sidebar stands, so the popup keeps clear of it; the search builder sits in the panel (wide)
  readonly sidebar = input<'closed' | 'open' | 'wide'>('wide');

  // Set in ngOnInit - the input isn't available in a field initializer.
  private readonly operatorsObjectTypeId = signal<number | null>(null);
  private readonly feedOperatorHintsQuery = injectFeedOperatorHintsQuery(
    this.operatorsObjectTypeId,
  );

  feedOperators$: Observable<Array<FeedOperatorHint>> = toObservable(
    computed(() => this.feedOperatorHintsQuery.data() ?? []),
  );

  @Output() close = new EventEmitter<void>();
  @Output() hintSelected = new EventEmitter<string>();

  ngOnInit(): void {
    if (this.objectTypeId) {
      this.operatorsObjectTypeId.set(this.objectTypeId);
    }
  }

  onCloseClick() {
    this.close.emit();
  }

  addOperator(operatorName: any) {
    this.hintSelected.emit(operatorName);
  }
}
